<!--
 * @Author: your name
 * @Date: 2020-12-31 20:23:02
 * @LastEditTime: 2021-01-04 22:16:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /SharingPowerBankadmin/src/views/Login.vue
-->
<template>
  <div class="login">
    <div class="login-bg">
      <img src="../assets/images/login_bg.png" alt="" srcset="" />
    </div>
    <div class="login-content">
      <p class="login-title">叮咛-回收站/仓库/大区运营后台系统</p>
      <el-card>
        <p class="form-title">欢迎登录</p>
        <div style="margin-top: 30px"></div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="username">
            <el-input
              prefix-icon="el-icon-user"
              v-model="ruleForm.username"
              placeholder="请输入11位手机号"
            ></el-input>
          </el-form-item>
          <div style="margin-top: 30px"></div>

          <div class="v1">
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-key"
                v-model="ruleForm.password"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>

            <div class="v2" @click="getcodem">
              {{ !codeTime ? "获取验证码" : codeTime + "s" }}
            </div>
          </div>

          <div style="margin-top: 30px"></div>
          <el-form-item>
            <el-button
              style="width: 100%"
              type="primary"
              @click="submitForm('ruleForm')"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
        <p class="login-code" @click="hreftwo">密码登录</p>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      codeTime: "",
      ruleForm: {
        username: "",
        password: "",
      },
      checked: false,
      rules: {
        username: [
          { required: true, message: "请输入11位手机号", trigger: "blur" },
          { min: 11, max: 11, message: "长度为11位数字", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 8, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // console.log(this.$api)
  },
  methods: {
    getyanzm() {
      this.$api.Historyorderapi.sendSmsYZM({
        phoneNum: this.ruleForm.username,
      }).then((d) => {
             if (d.code==200) {
                this.$message({
          message: '发送成功',
          type: 'success'
        });
             }else{
                this.$message.error(d.msg);
             }

      });
    },

    hreftwo(){

       this.$router.push({ path:'Login'})


    },

    getcodem() {
      if (this.ruleForm.username.length != 11) {
        this.$message.error("请输入完整的手机号");
      } else if (this.codeTime > 0) {
        this.$message.error("不能重复获取");
      } else {
        this.codeTime = 60;

        this.getyanzm();
        // 写逻辑
        let timer = setInterval(() => {
          this.codeTime--;
          if (this.codeTime < 1) {
            clearInterval(timer);
            this.codeTime = 0;
          }
        }, 1000);
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.Historyorderapi
            .loginByCode({
             code:this.ruleForm.password,
             customerPhone:this.ruleForm.username,

            })
            .then((d) => {
             if (d.code==200) {
                  this.$store.dispatch("set_token", d.data);
                // this.info();
                  this.$router.push('/')
             }else{
                  this.$message.error(d.msg);
             }
              
            
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

   info () {
      this.$api.admincustomer.customerinfo({}).then(d => {
        // console.log('sdafsdf', d);
        if (d.code == 200) {
          // console.log(d.data);
               this.$store.dispatch("set_token", d.data.token);
            this.$$store.dispatch("set_roleId", data.roleId)
          this.$router.push('/')
        } else {
          this.$message.error(d.msg);
        }
      }).catch((e) => {
        console.log(e);
      })
    },
 
  },
};
</script>

<style scoped>
.v2 {
  width: 105px;
  height: 36px;
  background: #ffffff;
  border: 2px solid var(--table-border);
  opacity: 1;
  border-radius: 6px;

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: #5184f7;
  opacity: 1;

  display: flex;
  justify-content: center;
  align-items: center;
}

.v1 {
  display: flex;
  justify-content: space-between;

  /* background: #FFFFFF;
border: 2px solid var(--table-border);
opacity: 1;
border-radius: 6px; */
}
.login-bg > img {
  width: 100%;
  height: 99.7vh;
}
.login-content {
  position: absolute;
  left: 80%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.login-title {
  width: 100%;
  height: 40px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #0e3d95;
  opacity: 1;
  margin-bottom: 30px;
}
.el-card {
  width: 500px;
  height: 380px;
  border-radius: 23px;
}
.form-title {
  width: 96px;
  height: 31px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 31px;
  color: #1e71ff;
  opacity: 1;
  margin-bottom: 10px;
}
.checkbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.checkbox > p {
  font-size: 14px;
  cursor: pointer;
}
.login-code {
  text-align: center;
  font-size: 14px;
  color: #5184f7;
  margin-top: 50px;
  cursor: pointer;
}
</style>
